import { twMerge } from 'tailwind-merge';
import { classes, styles } from './utils';

export type ChartLegendItem = {
  label: string;
  color: string;
  shape?: 'square' | 'line';
};

export type ChartLegendProps = {
  className?: string;
  items: ChartLegendItem[];
};

export default function ChartLegend({ className, items }: ChartLegendProps) {
  return (
    <div className={twMerge(classes.legend, className)}>
      {items.map(({ label, color, shape = 'square' }) => (
        <span key={label} className={classes.item}>
          <span
            style={styles.swatch(color)}
            className={shape === 'line' ? classes.line : classes.swatch}
          />
          {label}
        </span>
      ))}
    </div>
  );
}
